// extracted by mini-css-extract-plugin
module.exports = {"location-list":"ComboBox2_location-list__3zg0L","location-list-item":"ComboBox2_location-list-item__1cNeH"};